<template>
  <section>
    <h2 class="my-4">
      Moderator: <strong>{{ moderator.name }}</strong
      ><span v-if="isDeleted" class="badge badge-danger ml-3">GELÖSCHT</span>
    </h2>
    <div class="d-flex mb-4">
      <moderator-update :moderator="moderator"></moderator-update>
      <div v-if="isAdmin" class="card ml-5 flex-grow-1">
        <div class="card-body">
          <v-button :working="working" @click.native="toggleAgencyLeader()">
            <span v-if="agencyLeader"> Agenturleitung entziehen</span>
            <span v-else> Agenturleitung erteilen</span>
          </v-button>
        </div>
      </div>
    </div>
    <div class="d-flex mb-4">
      <v-table
        class="flex-grow-1"
        url="/api/v1/message"
        :filter="[
          {
            name: 'with',
            value: ['sender', 'receiver']
          },
          {
            name: 'where',
            attributes: {
              moderator_profile_id: moderator.moderator_profile.id
            }
          }
        ]"
        :attributes="[
          {
            name: 'Dialog',
            attribute: 'dialogMessageId',
            type: 'ClickableIdCell',
            sortable: false
          },
          {
            attribute: 'sender',
            name: 'Von',
            type: 'ProfileCell'
          },
          {
            attribute: 'receiver',
            name: 'An',
            type: 'ProfileCell'
          },
          {
            attribute: 'dEType',
            name: 'Nachrichtentyp',
            sortable: false
          },
          {
            attribute: 'body',
            name: 'Nachricht'
          },
          {
            attribute: 'created_at',
            name: 'Datum',
            type: 'DateTimeCell'
          }
        ]"
      >
        <div slot="title">
          Nachrichten
        </div>
      </v-table>
    </div>

    <div class="col-12 bg-white p-0 mb-4">
      <div class="flex-row">
        <v-table
          class="flex-grow-1"
          :url="historyUrl"
          :attributes="[
            {
              name: 'Heute',
              attribute: 'today'
            },
            {
              attribute: 'this week',
              name: 'Diese Woche'
            },
            {
              attribute: 'last week',
              name: 'Letzte Woche'
            },
            {
              attribute: 'this month',
              name: 'Dieser Monat'
            },
            {
              attribute: 'last month',
              name: 'letzter Monat'
            },
            {
              attribute: 'all',
              name: 'Total'
            }
          ]"
        >
          <span slot="title">Statistik INs / Outs [Transactions] </span>
        </v-table>
      </div>
      <div class="flex-row">
        <v-table
          url="/api/v1/moderator-transaction/"
          :filter="earningsFilter"
          :attributes="[
            {
              attribute: 'price',
              name: 'Einheiten'
            },
            {
              attribute: 'created_at',
              name: 'Am',
              type: 'DateTimeCell'
            }
          ]"
          ref="table-transactions"
        >
          <div slot="filter">
            <table-filter
              :filterComponents="[
                {
                  type: 'DateRangeFilter',
                  label: 'Zeitraum'
                }
              ]"
              v-model="earningsFilter"
              @apply-filters="
                $bus.$emit('refresh-table', $refs['table-transactions'].id)
              "
            ></table-filter>
          </div>
        </v-table>
      </div>
    </div>
    <div class="mb-4">
      <v-table
        url="/api/v1/moderatorWorkSession"
        :filter="workSessionFilter"
        :attributes="[
          {
            attribute: 'created_at',
            name: 'Von',
            type: 'DateTimeCell'
          },
          {
            attribute: 'completed_at',
            name: 'Bis',
            type: 'DateTimeCell'
          },
          {
            attribute: 'duration',
            name: 'Zeitraum'
          }
        ]"
        ref="table-work-sessions"
      >
        <span slot="title">Arbeitszeiten</span>
        <div slot="filter">
          <table-filter
            :filterComponents="[
              {
                type: 'DateRangeFilter',
                label: 'Zeitraum'
              }
            ]"
            v-model="workSessionFilter"
            @apply-filters="
              $bus.$emit('refresh-table', $refs['table-work-sessions'].id)
            "
          ></table-filter>
        </div>
      </v-table>
    </div>
    <admin-support-message-resource
      v-if="isAdmin"
      :moderatorId="moderator.id"
    ></admin-support-message-resource>
    <div v-if="!isDeleted && isAdmin" class="row">
      <div class="col-12">
        <v-table
          url="/api/v1/userSession"
          :filter="[
            {
              name: 'where',
              attributes: {
                user_id: this.id
              }
            }
          ]"
          :attributes="[
            {
              attribute: 'ip',
              name: 'IP-Adresse'
            },
            {
              attribute: 'country_code',
              name: 'Land',
              type: 'FlagCell'
            },
            {
              attribute: 'session_id',
              name: 'Session-ID'
            },
            {
              attribute: 'user_agent',
              name: 'Browser- und Gerätedaten'
            },
            {
              attribute: 'created_at',
              name: 'Erstellt am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'closed_at',
              name: 'Geschlossen am',
              type: 'DateTimeCell'
            },
            {
              attribute: 'duration',
              name: 'Zeitspanne'
            },
            {
              attribute: 'success',
              name: 'Erfolgreich eingeloggt',
              type: 'CheckMarkerCell'
            }
          ]"
        >
          <div slot="title">Anmeldungen</div>
        </v-table>
      </div>
    </div>
    <div v-if="!isDeleted && isAdmin" class="row">
      <div class="col-12">
        <v2-table
          :url="
            `/api/v1/ping?filter[moderator_profile_id]=${this.moderator.moderator_profile.id}&paginate`
          "
          :headers="[
            {
              text: 'Start'
            },
            {
              text: 'Ende'
            },
            {
              text: 'Durchschnitt'
            }
          ]"
        >
          <tr slot="row" slot-scope="{ item }">
            <date-time-cell :content="item.started_at" />
            <date-time-cell :content="item.ended_at" />
            <td>{{ item.average }} ms</td>
          </tr>
        </v2-table>
      </div>
    </div>
  </section>
</template>

<script>
import store from "@/store";
import AdminSupportMessageResource from "@/components/resources/AdminSupportMessageResource";
import ModeratorUpdate from "@/components/Moderator/Update";
import moment from "moment";
import DateTimeCell from "@/components/table/DateTimeCell";

export default {
  components: {
    AdminSupportMessageResource,
    ModeratorUpdate,
    DateTimeCell
  },
  props: {
    moderator: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      submitted: false,
      working: false,
      earningsFilter: [],
      workSessionFilter: []
    };
  },
  methods: {
    toggleAgencyLeader() {
      this.working = true;
      this.$http
        .post(`/api/v1/moderator/${this.id}/toggle-agency-leader`)
        .then(() => {
          store.dispatch("user/read", [
            {
              name: "where",
              attributes: {
                id: this.id
              }
            },
            {
              name: "with",
              value: ["moderatorProfile", "moderatorProfile.agency"]
            }
          ]);
        })
        .finally(() => {
          this.working = false;
        });
    }
  },
  computed: {
    id() {
      return this.moderator.id;
    },
    historyUrl() {
      return `/api/v1/moderator-transaction/history/${this.moderator.moderator_profile.id}`;
    },
    agencyLeader() {
      return this.moderator.roles.reduce((accumulator, role) => {
        return accumulator || role.name === "agency_leader";
      }, false);
    },
    isAdmin() {
      return store.getters["user/meHasRole"]("admin");
    },
    isDeleted() {
      return this.moderator.deleted_at !== null;
    }
  },
  created() {
    this.earningsFilter = [
      {
        name: "take",
        value: 10
      },
      {
        name: "where",
        attributes: {
          moderator_id: this.moderator.moderator_profile.id
        }
      },
      {
        name: "whereDate",
        id: 0,
        attributes: [
          {
            column: "created_at",
            operator: ">=",
            value: moment()
              .startOf("month")
              .format("YYYY-MM-DD")
          },
          {
            column: "created_at",
            operator: "<=",
            value: moment()
              .endOf("month")
              .format("YYYY-MM-DD")
          }
        ]
      }
    ];
    this.workSessionFilter = [
      {
        name: "take",
        value: 10
      },
      {
        name: "where",
        attributes: {
          moderator_profile_id: this.moderator.moderator_profile.id
        }
      },
      {
        name: "whereDate",
        id: 0,
        attributes: [
          {
            column: "created_at",
            operator: ">=",
            value: moment()
              .startOf("month")
              .format("YYYY-MM-DD")
          },
          {
            column: "created_at",
            operator: "<=",
            value: moment()
              .endOf("month")
              .format("YYYY-MM-DD")
          }
        ]
      }
    ];
    // table is using default filter without this
    this.$bus.$emit("refresh-table");
    this.$bus.$on("resource-persisted", () => (this.submitted = true));
  }
};
</script>
